module.exports = __webpack_public_path__ + "static/media/golf.91768f5c.svg";